import React from 'react';
import { clsx } from 'clsx';
import classes from './BranchName.module.css.js';
import { BoxWithFallback } from '../internal/components/BoxWithFallback.js';
import { jsx } from 'react/jsx-runtime';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function BranchName(props, ref) {
  const {
    as: Component = 'a',
    className,
    children,
    ...rest
  } = props;
  return /*#__PURE__*/jsx(BoxWithFallback, {
    as: Component,
    ...rest,
    ref: ref,
    className: clsx(className, classes.BranchName),
    children: children
  });
}
BranchName.displayName = "BranchName"; // eslint-disable-next-line @typescript-eslint/no-empty-object-type
const fixedForwardRef = React.forwardRef;

// eslint-disable-next-line @typescript-eslint/no-explicit-any

BranchName.displayName = 'BranchName';
var BranchName$1 = fixedForwardRef(BranchName);

export { BranchName$1 as default };
